import React from "react";
import "./Store.scss";
import StoreTag from "../StoreTag/StoreTag";
import BasicTag from "../BasicTag/BasicTag";

class Store extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      storeData: props.storeData,
      onClickedTag: props.onClickedTag,
    };
    this.onFilterClick = this.onFilterClick.bind(this);
  }
  render() {
    return (
      <>
        <div className="storeContainer mx-auto">
          <a
            href={this.state.storeData["URL"]}
            target="_blank"
            rel="noreferrer"
            className="storeImageLink"
          >
            <div
              className="storeImage"
              style={{
                backgroundImage: `url(
                  ${this.state.storeData["Asset Entrepreneur Pic"]}
                )`,
              }}
            ></div>
          </a>
          <div className="storeDetails">
            <div className="storeTags">
              <StoreTag
                key={this.state.storeData["Product Category"]}
                tag={this.state.storeData["Product Category"]}
                tagClass="categoryTag"
                type="Product Category"
                onTagClicked={this.onFilterClick}
              />
              <BasicTag
                key={this.state.storeData["AdditionalTags"]}
                tag={this.state.storeData["AdditionalTags"]}
              />
            </div>
          </div>
          <div className="storeName">
            <h2>{this.state.storeData["Business Name"]}</h2>
          </div>
          <div className="storeProperties">
            <h2>
              {this.state.storeData["Entrepreneur Name"]}
              {"   |   "}
              {this.state.storeData["CityState"]}
              {"   |   "}
              {this.state.storeData["Geography"]}
            </h2>
          </div>
          <div className="storeInfo">
            <p>{this.state.storeData["Products Description"]}</p>
            <div className="row">
              <a
                href={this.state.storeData["URL"]}
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary btn-red"
              >
                Shop Online
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }
  renderTags(store, attribute) {
    if (Array.isArray(store[attribute]) && store[attribute].length > 0) {
      return store[attribute].map((s) => this.renderTag(s));
    } else {
      return this.renderTag(store[attribute]);
    }
  }
  renderBasicTags(store, attribute) {
    if (Array.isArray(store[attribute]) && store[attribute].length > 0) {
      return store[attribute].map((s) => this.renderBasicTag(s));
    } else {
      return this.renderBasicTag(store[attribute]);
    }
  }
  renderBasicTag(tag) {
    return <BasicTag key={tag} tag={tag} tagClass="basicTag" />;
  }
  renderTag(tag) {
    return <StoreTag key={tag} tag={tag} onTagClicked={this.onFilterClick} />;
  }
  onFilterClick(e) {
    this.props.onClickedTag(e);
  }
}
export default Store;
